var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"no-more-tips",class:{'no-more-has-next': _vm.hasNext}},[_vm._v(_vm._s(_vm.tips))])}
var staticRenderFns = []

export { render, staticRenderFns }